/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>案例管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        
        
		<el-form label-width="120px" ref="editForm" :model="formProInfo" class="editForm">
		  <el-form-item label="回访名称" prop="productName">
		    <el-input size="small" v-model="formProInfo.name" auto-complete="off" placeholder="请输入回访名称"></el-input>
		  </el-form-item>
		  
		  
		  <el-form-item   label="回访内容">
		    <el-upload
		      class="upload-demo"
		      :action="uploadUrl()"
		      :http-request="customUpload"
		      :on-preview="handlePreview"
		      :on-remove="handleRemove"
		      :file-list="resultFilelist"
		      :limit='1'
		      accept=".mp4,.avi,.mpeg"
		      list-type="picture-card">
			  
		      <el-button size="small" type="primary">点击上传视频</el-button>
		      <div slot="tip" class="el-upload__tip">只能上传mp4、avi、mpeg 视频，最多可上传1个视频</div>
		      <div slot="file" slot-scope="{file}">
				<el-progress type="circle" :percentage="progressPercent" v-if="isUpload"></el-progress>
		        <video
		          class="el-upload-list__item-thumbnail"
		          :src="file.url" alt=""
		          :autoplay="true"
		        ></video>
		        <span class="el-upload-list__item-actions">
		          <!-- <span
		            class="el-upload-list__item-preview"
		            @click="handlePreview(file)"
		          >
		            <i class="el-icon-zoom-in"></i>
		          </span> -->
		          
		          <span
		            class="el-upload-list__item-delete"
		            @click="handleRemove(file)"
		          >
		            <i class="el-icon-delete"></i>
		          </span>
		        </span>
		      </div>
		    </el-upload>
			
		  
			
			
			
		  </el-form-item>
		  
		 
		 
		  
		</el-form>
		
		
		<div slot="footer" class="dialog-footer">
		  <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
		</div>
		
		
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getRecommendTypeList,
	  customerCase,
	  putcustomerCase,
	  getcustomerCase
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  uploadTimer: null,//调取进度条的轮询定时器
		  isUpload: false,//文件是否上传中
		  progressPercent: 0,//进度条当前进度
		  curPercentage: 0,
          loading: false, //是显示加载
		  keytype:0,
          title: '回访新增',
		  typeList1:'',
          // 请求数据参数
          formProInfo: {
            name: '',
            type:'回访案例',
            videoDtoList:[
				{
					fielId:''
				}
			]
          },
		  diaFrom:{
		    desc:'',
		    list:[]
		  },
    	  id:'',
		  shuo:'',
		 resultFilelist:[]
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {
		 
	  },

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)
		

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.shuo = this.$route.query.shuo
		  if(this.shuo=='新增'){
		  		this.title = '回访案例新增'
		  }else{
		  		this.title = '回访案例编辑'
		  		this.handleEdit()
		  }
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getcustomerCase(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         let data = res.data
		         this.formProInfo.name = data.caseName
		        
				 
				 this.resultFilelist = []
				 
				 this.resultFilelist.push({
				   url:data.queryVideoDtoList[0].fileTemporaryUrl,
				   fileTemporaryUrl:data.queryVideoDtoList[0].fileTemporaryUrl,
				   fileId:data.queryVideoDtoList[0].fileId
				 })
				 
				
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		  uploadUrl(){
		    return '/mtl/marking/api/main/oss-file/upload-file'
		  },
		  handlePreview(file){
		    console.log(file)
			
		  },
		 
		  customUpload(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
			this.isUpload = true
		    this.progressPercent = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
		  				 
		        if(response.data.success){
					this.progressPercent = 100
					setTimeout(()=>{
						this.isUpload = false
					},1500)
					
		          let data = response.data.data
		          console.log(8888888,data)
		          _this.resultFilelist.push({
		                  
						  url:data.fileTemporaryUrl,
						  fileTemporaryUrl:data.fileTemporaryUrl,
						  fileId:data.fileId,
						  name: data.ossFile.fileName,
						  uid: req.file.uid,
						  mediaObjInfo:data
						  
		              })
		            
		          
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		 
		  handleRemove(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index2 = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
		     console.log(index2)
		     this.resultFilelist.splice(index2,1);
		  },
		//编辑
		goback() {
			this.$router.push({ path: '/returnvisit'})
		 
		},
		
	  changetype(e){
		  let prm = {
			  category:this.formProInfo.category
		  }
		  getRecommendTypeList(prm).then(res => {
			console.log(123)
			this.loading = false
			if (res.success == false) {
			  this.$message({
				type: 'info',
				message: res.msg
			  })
			} else {
				this.typeList1 = res.data	
			
			}
		  })
	  },
	  
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


        
        
        // 编辑、添加提交方法
        saveProInfo(){
            console.log(this.content)
             if(!this.formProInfo.name){
              return this.$message({
                      type: 'warning',
                      message: '请填写分类名称'
                    })
            }
			
			if(this.resultFilelist.length==0){
				return this.$message({
				        type: 'warning',
				        message: '请上传文件！'
				      })
			}
			this.formProInfo.videoDtoList[0].fielId = this.resultFilelist[0].fileId
			console.log(999999978,this.formProInfo.videoDtoList,this.resultFilelist[0].fileId)
            if(this.shuo=='新增'){
				customerCase(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				   this.$router.push({ path: '/returnvisit'})
				  }
				})
			}else{
				this.formProInfo.videoDtoList[0].fielId = this.resultFilelist[0].fileId
				this.formProInfo.id = this.id
				// let parm = {
				// 	name:this.formProInfo.name,
				// 	category:this.formProInfo.category,
				// 	active:this.formProInfo.active,
				// 	id:this.formProInfo.id,
				// }
				putcustomerCase(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				   this.$router.push({ path: '/returnvisit'})
				  }
				})
			}
          
    		
        },

       

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
       
        

      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		height: 85%;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tips{
	  color: #8c939d;
  }
    </style>





// WEBPACK FOOTER //
// src/views/management/returnvisitadd.vue